// CandidatosUpload.tsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CandidatosUploadList from './CandidatosUploadList';
import { useBreadcrumbs } from '../../Routes/BreadcrumbContext';
import { createBreadcrumbs } from '../../utils/breadcrumbUtils';
import { Alert } from 'react-bootstrap';
import api from '../../api';
import HelpDrawerCandidatos from './components/HelpDrawerCandidatos';
import { BsQuestionCircle } from 'react-icons/bs';

// types/processo.ts
export interface Unidade {
    id: string;
    nome: string;
    clientId: string;
}

export interface Link {
    rel: string;
    href: string;
}

export interface Cronograma {
    id: string;
    atividades: any[]; // Você pode tipar melhor se souber a estrutura
    _links: Link[];
}

export interface Edital {
    id: string;
    nome: string;
    processoId: string;
    processoNome: string;
    candidatos: any[]; // Você pode tipar melhor se souber a estrutura
}

export interface Processo {
    id: string;
    nome: string;
    unidade: Unidade;
    identificador: string;
    responsavel: string;
    cronograma: Cronograma;
    salaEspera: any | null; // Você pode tipar melhor
    dataCriacao: string;
    status: string;
    _links: Link[];
    editais: Edital[];
    numeroCandidatos: number;
    finalizavel: boolean;
    convocacoesEnviadas: boolean;
    nomeEditavel: boolean;
    cronogramaDefinido: boolean;
    bancasTerminadas: boolean;
}

const CandidatosUpload: React.FC = () => {
    const { processoId } = useParams<{ processoId: string }>();
    const { setBreadcrumbs } = useBreadcrumbs();
    const [showAlert, setShowAlert] = useState<boolean>(true);
    const [processo, setProcesso] = useState<Processo | null>(null);
    const [showHelpDrawer, setShowHelpDrawer] = useState(false);

    const fetchProcesso = async (processoId: string) => {
        try {
            const response = await api.get(`/processos/${processoId}`);
            setProcesso(response.data);
        } catch (err) {
            console.error('Erro ao carregar processo:', err);
        }
    };

    useEffect(() => {
        setBreadcrumbs(createBreadcrumbs.fromProcessos([
            { path: `/processos/${processoId!}/candidatos/upload`, breadcrumb: 'Candidatos' },
        ]));
        fetchProcesso(processoId!);
    }, [setBreadcrumbs, processoId]);

    return (
        <HelpDrawerCandidatos isOpen={showHelpDrawer} onClose={() => setShowHelpDrawer(false)}>
        <div className="container mt-4">
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
                <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => setShowHelpDrawer(true)}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}
                >
                    <BsQuestionCircle /> Ajuda
                </button>
            </div>
            {showAlert && (
                <Alert variant="info" onClose={() => setShowAlert(false)} dismissible>
                    <Alert.Heading>Observação</Alert.Heading>
                    <p>Toda modificação realizada nesta página e no restante do sistema é salva em auditoria, para segurança e conformidade com os objetivos do Identifica</p>
                </Alert>
            )}
            <CandidatosUploadList processoId={processoId!} />
        </div>
        </HelpDrawerCandidatos>
    );
};

export default CandidatosUpload;